/* Aphrae — one delegated add-to-cart handler for every CTA in the theme.
   Any element with data-ap-cart-add="<variantId>" adds that variant and
   refreshes whichever cart UI the theme is configured for. */
(function () {
  function cartUI() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function fail(el, message) {
    var box = el.parentElement && el.parentElement.querySelector('[data-ap-cart-error]');
    if (box) {
      box.hidden = false;
      box.textContent = message + ' — taking you to the product page…';
    }
    var href = el.getAttribute('href');
    setTimeout(function () { window.location = href && href !== '#' ? href : '/cart'; }, 1200);
  }

  function add(el, id) {
    var ui = cartUI();

    // Single-item form, not { items: [...] }. The multi-item endpoint returns
    // a cart object with no `key`, and Dawn's cart-notification builds its
    // section selector from parsedState.key — a missing key makes it query
    // [id="cart-notification-product-undefined"], which is null, and then
    // throws "Cannot read properties of null (reading 'innerHTML')".
    var body = { id: Number(id), quantity: 1 };
    if (ui && typeof ui.getSectionsToRender === 'function') {
      body.sections = ui.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    var url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    el.setAttribute('aria-busy', 'true');
    var box = el.parentElement && el.parentElement.querySelector('[data-ap-cart-error]');
    if (box) { box.hidden = true; box.textContent = ''; }

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'Could not add to cart');
        if (ui && typeof ui.renderContents === 'function' && data.sections) {
          ui.renderContents(data);
        } else {
          window.location = '/cart';
        }
      })
      .catch(function (e) { fail(el, e.message); })
      .finally(function () { el.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-ap-cart-add]') : null;
    if (!el) return;
    var id = el.getAttribute('data-ap-cart-add');
    if (!id) return;
    e.preventDefault();
    add(el, id);
  });
})();
